import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import style from './style.css';

const ReportHeader = props => {
    const { filters } = props;

    const {
        header: { title, createdDateText, schoolYearText },
    } = props.settings;

    const getReportTypeText = () => {
        if (filters && filters.schoolType) {
            if (filters.schoolType === 'national_Public Schools') {
                return 'All Public Schools';
            }
            return 'All Schools (Public and Private)';
        }
        return '';
    };

    return (
        <div className={style.headerWrapper}>
            <div className={style.headerLeft}>
                <div className={style.logo} />
            </div>
            <div className={style.headerRight}>
                <div className={style.title}>
                    <div className={style.groupName}>{title}</div>
                    <div className={style.reportType}>{getReportTypeText()}</div>
                </div>
                <div className={style.info}>
                    <div>
                        <span style={{ fontWeight: 'bold' }}>{createdDateText} </span>
                        {moment(new Date()).format('MMMM Do YYYY')}
                    </div>
                    <div>
                        <span style={{ fontWeight: 'bold' }}>{schoolYearText} </span>
                        <span style={{ textTransform: 'capitalize' }}>{filters.schoolYear.slice(0, 9)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

ReportHeader.propTypes = {
    settings: PropTypes.object,
    filters: PropTypes.object,
    schoolType: PropTypes.string,
    group: PropTypes.object,
    schoolYear: PropTypes.string,
    groupType: PropTypes.string,
};

ReportHeader.defaultProps = {
    settings: {
        header: {
            title: 'Overview Report',
            createdDateText: 'Report Created On:',
            schoolYearText: 'School Year:',
            schoolTypeText: 'School Type:',
        },
    },
    group: { groupType: 'state', label: 'My Group' },
    groupType: 'state',
};

export default ReportHeader;
